import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { JwtAuthService } from '../services/auth/jwt-auth.service';
import { AuthorizeEntityService } from '../../state/entity-services/authorize-entity.service';
import { map } from 'rxjs/operators';
import { PatientService } from '../../views/patient/services/patient.service';

@Injectable()
export class PatientWaitingFormSubmissionGuard implements CanActivate {
  constructor(
    private patientService: PatientService,
    private jwtAuthService: JwtAuthService,
    private autorizeEntityService: AuthorizeEntityService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.patientService.setAuthorize(null);
    if (!this.jwtAuthService.isLoggedIn) {
      this.router.navigate(['/paciente/login/boas-vindas'], {
        queryParams: {
          loginFrom: window.location.href,
        },
      });
      return of(false);
    }
    const { queryParams } = route;

    delete queryParams['loginFrom'];

    return this.autorizeEntityService.getAutorize(queryParams).pipe(
      map(response => {
        this.patientService.setAuthorize(response);
        return !!response;
      })
    );
  }
}
